module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-10.161e8f32.jpg";